// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: PP-Nuebit;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: N27;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: N27-Bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: N27-Light;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.course-desc-container {
  background-color: white;
  min-height: 100vh;
}
.course-desc-container .upper-box {
  display: flex;
  min-height: 16.75rem;

  .box-1 {
    width: 30%;
    display: flex;
    align-items: center;

    .box-container {
      width: 50%;
      height: 80%;
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .box {
        border: 1px solid black;
        padding-inline: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: N27;
        font-weight: 400;
        font-size: 1.25rem;
        height: 2.375rem;
        background-color: white;
        width: -moz-fit-content;
        width: fit-content;
        cursor: pointer;
      }
      .box-active {
        padding-inline: 1rem;
        border: 3px dashed white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: N27;
        font-weight: 400;
        font-size: 1.25rem;
        height: 2.375rem;
        background-color: #000000;
        color: white;
        width: -moz-fit-content;
        width: fit-content;
      }
    }
  }
  .box-2 {
    width: 60%;
    display: flex;
    align-items: center;
    .box {
      .text {
        display: flex;
        flex-direction: column;
        .t-1 {
          font-size: 1.25rem;
          text-align: left;
          font-family: N27-Light;
        }
        .t-2 {
          text-align: left;
          font-size: 12.25rem;
          font-family: PP-Nuebit;
          margin: 0;
        }
      }
    }
  }
  .box-3 {
    width: 30%;
    display: flex;
    align-items: center;
    .desc-content {
      width: 80%;
      .course-heading {
        font-family: N27;
        text-align: left;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
      }
      .course-para {
        font-size: 1rem;
        font-style: italic;
        text-align: left;
        font-family: N27;
      }
    }
  }
}
.course-desc-container .lower-box {
  /* height: 45rem; */
  display: flex;
  align-items: center;
  justify-content: center;
  .box-container {
    /* height: 44rem; */
    width: 95%;
    display: flex;
    justify-content: space-between;
    .box-1 {
      width: 30%;
      /* height: 100%; */
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .course-content-box {
        height: -moz-fit-content;
        height: fit-content;
        .course-content-title {
          height: 3.5rem;
          display: flex;
          font-family: N27;
          align-items: center;
          justify-content: space-between;
          padding-inline: 1rem;
          border: 0.25px solid #9c9c9c;
          cursor: pointer;
        }
        .course-content-title-active {
          height: 3.5rem;
          display: flex;
          font-family: N27;
          align-items: center;
          justify-content: space-between;
          padding-inline: 1rem;
          border: 0.25px solid #9c9c9c;
          cursor: pointer;
          background-color: #ff4f4f;
        }
      }
      .course-progress-box {
        height: 16.313rem;
        position: relative;
        border: 0.25px solid #9c9c9c;
        /* margin-top: 15rem; */

        .progress-container {
          .progress-para {
            position: absolute;
            right: 40%;
            color: black;
          }
          .progress-text {
            position: absolute;
            right: 0.5rem;
            color: black;
          }
        }
        .help-section-container {
          width: 100%;
          height: calc(100% - 2.5rem);
          display: flex;
          justify-content: center;
          align-items: center;
          .help-section {
            width: 80%;
            height: -moz-fit-content;
            height: fit-content;
            .help-section-heading {
              font-size: 2rem;
              font-family: N27;
              text-align: left;
            }
            .help-section-para {
              font-size: 1rem;
              font-family: N27-Light;
              text-align: left;
              font-style: italic;
              margin-bottom: 1.5rem;
            }
          }
        }
      }
    }
    .box-2 {
      border: 1px solid #3d3d3d;
      width: 65%;
      height: 100%;
      .content-header {
        border: 1px solid #9c9c9c;
        height: 4.25rem;
        display: flex;
        justify-content: space-between;
        padding-inline: 1.5rem;
        align-items: center;
        .expand-more {
          cursor: pointer;
        }
        .content-level {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          .circle-green {
            width: 0.75rem;
            height: 0.75rem;
            border-radius: 50%;
            background-color: green; /* Change the color as needed */
          }
          .circle-orange {
            width: 0.75rem;
            height: 0.75rem;
            border-radius: 50%;
            background-color: orange; /* Change the color as needed */
          }
          .circle-red {
            width: 0.75rem;
            height: 0.75rem;
            border-radius: 50%;
            background-color: red; /* Change the color as needed */
          }
          .content-header-heading {
            font-family: N27;
            font-size: 1.5rem;
          }
        }
        .content-heading {
          font-size: 3.5rem;
          font-family: PP-Nuebit;
          font-weight: bold;
        }

        .content-time {
          display: flex;
          gap: 1.5rem;
          .content-text {
            font-size: 1.25rem;
            font-family: N27;
          }
        }
      }
      .content-header-content {
        border: 1px solid #9c9c9c;
        background-color: #F5F5F5;
        /* height: 25.688rem;  */
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 1.5rem;

        .content-header-box {
          /* height: 22.688rem; */
          width: 95%;
          display: flex;
          flex-direction: column;
          /* overflow-y: scroll; */
          /* border: 1px solid rgb(2, 57, 236); */
          .content-course-detail {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
            .content-course-detail-text {
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              .content-course-detail-text-header {
                display: flex;
                font-family: N27;
                font-size: 1.25rem;
                display: flex;
                align-items: center;
                .text {
                  margin-left: 0.5rem;
                }
                .image {
                  margin-left: 1rem;
                }
              }
              .text-para {
                margin-left: 2.1rem;
                font-family: N27-Light;
                font: italic;
                color: #7b7b7b;
              }
              .text-para {
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/CourseDescription/courseDescription.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4CAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,4CAAiD;AACnD;AACA;EACE,qBAAqB;EACrB,4CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,4CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,oBAAoB;;EAEpB;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;;IAEnB;MACE,UAAU;MACV,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,SAAS;;MAET;QACE,uBAAuB;QACvB,oBAAoB;QACpB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;QAChB,uBAAuB;QACvB,uBAAkB;QAAlB,kBAAkB;QAClB,eAAe;MACjB;MACA;QACE,oBAAoB;QACpB,wBAAwB;QACxB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;QAChB,yBAAyB;QACzB,YAAY;QACZ,uBAAkB;QAAlB,kBAAkB;MACpB;IACF;EACF;EACA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB;MACE;QACE,aAAa;QACb,sBAAsB;QACtB;UACE,kBAAkB;UAClB,gBAAgB;UAChB,sBAAsB;QACxB;QACA;UACE,gBAAgB;UAChB,mBAAmB;UACnB,sBAAsB;UACtB,SAAS;QACX;MACF;IACF;EACF;EACA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB;MACE,UAAU;MACV;QACE,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,qBAAqB;MACvB;MACA;QACE,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;MAClB;IACF;EACF;AACF;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;IACE,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B;MACE,UAAU;MACV,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,8BAA8B;MAC9B;QACE,wBAAmB;QAAnB,mBAAmB;QACnB;UACE,cAAc;UACd,aAAa;UACb,gBAAgB;UAChB,mBAAmB;UACnB,8BAA8B;UAC9B,oBAAoB;UACpB,4BAA4B;UAC5B,eAAe;QACjB;QACA;UACE,cAAc;UACd,aAAa;UACb,gBAAgB;UAChB,mBAAmB;UACnB,8BAA8B;UAC9B,oBAAoB;UACpB,4BAA4B;UAC5B,eAAe;UACf,yBAAyB;QAC3B;MACF;MACA;QACE,iBAAiB;QACjB,kBAAkB;QAClB,4BAA4B;QAC5B,uBAAuB;;QAEvB;UACE;YACE,kBAAkB;YAClB,UAAU;YACV,YAAY;UACd;UACA;YACE,kBAAkB;YAClB,aAAa;YACb,YAAY;UACd;QACF;QACA;UACE,WAAW;UACX,2BAA2B;UAC3B,aAAa;UACb,uBAAuB;UACvB,mBAAmB;UACnB;YACE,UAAU;YACV,wBAAmB;YAAnB,mBAAmB;YACnB;cACE,eAAe;cACf,gBAAgB;cAChB,gBAAgB;YAClB;YACA;cACE,eAAe;cACf,sBAAsB;cACtB,gBAAgB;cAChB,kBAAkB;cAClB,qBAAqB;YACvB;UACF;QACF;MACF;IACF;IACA;MACE,yBAAyB;MACzB,UAAU;MACV,YAAY;MACZ;QACE,yBAAyB;QACzB,eAAe;QACf,aAAa;QACb,8BAA8B;QAC9B,sBAAsB;QACtB,mBAAmB;QACnB;UACE,eAAe;QACjB;QACA;UACE,aAAa;UACb,mBAAmB;UACnB,WAAW;UACX;YACE,cAAc;YACd,eAAe;YACf,kBAAkB;YAClB,uBAAuB,EAAE,+BAA+B;UAC1D;UACA;YACE,cAAc;YACd,eAAe;YACf,kBAAkB;YAClB,wBAAwB,EAAE,+BAA+B;UAC3D;UACA;YACE,cAAc;YACd,eAAe;YACf,kBAAkB;YAClB,qBAAqB,EAAE,+BAA+B;UACxD;UACA;YACE,gBAAgB;YAChB,iBAAiB;UACnB;QACF;QACA;UACE,iBAAiB;UACjB,sBAAsB;UACtB,iBAAiB;QACnB;;QAEA;UACE,aAAa;UACb,WAAW;UACX;YACE,kBAAkB;YAClB,gBAAgB;UAClB;QACF;MACF;MACA;QACE,yBAAyB;QACzB,yBAAyB;QACzB,wBAAwB;QACxB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;;QAEnB;UACE,uBAAuB;UACvB,UAAU;UACV,aAAa;UACb,sBAAsB;UACtB,wBAAwB;UACxB,uCAAuC;UACvC;YACE,WAAW;YACX,aAAa;YACb,8BAA8B;YAC9B,mBAAmB;YACnB,qBAAqB;YACrB;cACE,aAAa;cACb,sBAAsB;cACtB,WAAW;cACX;gBACE,aAAa;gBACb,gBAAgB;gBAChB,kBAAkB;gBAClB,aAAa;gBACb,mBAAmB;gBACnB;kBACE,mBAAmB;gBACrB;gBACA;kBACE,iBAAiB;gBACnB;cACF;cACA;gBACE,mBAAmB;gBACnB,sBAAsB;gBACtB,YAAY;gBACZ,cAAc;cAChB;cACA;gBACE,gBAAgB;cAClB;YACF;UACF;QACF;MACF;IACF;EACF;AACF","sourcesContent":["@font-face {\n  font-family: PP-Nuebit;\n  src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n@font-face {\n  font-family: N27;\n  src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n}\n@font-face {\n  font-family: N27-Bold;\n  src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n}\n@font-face {\n  font-family: N27-Light;\n  src: url(\"../../../assets/Fonts/N27-Light.otf\");\n}\n\n.course-desc-container {\n  background-color: white;\n  min-height: 100vh;\n}\n.course-desc-container .upper-box {\n  display: flex;\n  min-height: 16.75rem;\n\n  .box-1 {\n    width: 30%;\n    display: flex;\n    align-items: center;\n\n    .box-container {\n      width: 50%;\n      height: 80%;\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n\n      .box {\n        border: 1px solid black;\n        padding-inline: 1rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-family: N27;\n        font-weight: 400;\n        font-size: 1.25rem;\n        height: 2.375rem;\n        background-color: white;\n        width: fit-content;\n        cursor: pointer;\n      }\n      .box-active {\n        padding-inline: 1rem;\n        border: 3px dashed white;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-family: N27;\n        font-weight: 400;\n        font-size: 1.25rem;\n        height: 2.375rem;\n        background-color: #000000;\n        color: white;\n        width: fit-content;\n      }\n    }\n  }\n  .box-2 {\n    width: 60%;\n    display: flex;\n    align-items: center;\n    .box {\n      .text {\n        display: flex;\n        flex-direction: column;\n        .t-1 {\n          font-size: 1.25rem;\n          text-align: left;\n          font-family: N27-Light;\n        }\n        .t-2 {\n          text-align: left;\n          font-size: 12.25rem;\n          font-family: PP-Nuebit;\n          margin: 0;\n        }\n      }\n    }\n  }\n  .box-3 {\n    width: 30%;\n    display: flex;\n    align-items: center;\n    .desc-content {\n      width: 80%;\n      .course-heading {\n        font-family: N27;\n        text-align: left;\n        font-size: 1.5rem;\n        margin-bottom: 0.5rem;\n      }\n      .course-para {\n        font-size: 1rem;\n        font-style: italic;\n        text-align: left;\n        font-family: N27;\n      }\n    }\n  }\n}\n.course-desc-container .lower-box {\n  /* height: 45rem; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .box-container {\n    /* height: 44rem; */\n    width: 95%;\n    display: flex;\n    justify-content: space-between;\n    .box-1 {\n      width: 30%;\n      /* height: 100%; */\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      .course-content-box {\n        height: fit-content;\n        .course-content-title {\n          height: 3.5rem;\n          display: flex;\n          font-family: N27;\n          align-items: center;\n          justify-content: space-between;\n          padding-inline: 1rem;\n          border: 0.25px solid #9c9c9c;\n          cursor: pointer;\n        }\n        .course-content-title-active {\n          height: 3.5rem;\n          display: flex;\n          font-family: N27;\n          align-items: center;\n          justify-content: space-between;\n          padding-inline: 1rem;\n          border: 0.25px solid #9c9c9c;\n          cursor: pointer;\n          background-color: #ff4f4f;\n        }\n      }\n      .course-progress-box {\n        height: 16.313rem;\n        position: relative;\n        border: 0.25px solid #9c9c9c;\n        /* margin-top: 15rem; */\n\n        .progress-container {\n          .progress-para {\n            position: absolute;\n            right: 40%;\n            color: black;\n          }\n          .progress-text {\n            position: absolute;\n            right: 0.5rem;\n            color: black;\n          }\n        }\n        .help-section-container {\n          width: 100%;\n          height: calc(100% - 2.5rem);\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          .help-section {\n            width: 80%;\n            height: fit-content;\n            .help-section-heading {\n              font-size: 2rem;\n              font-family: N27;\n              text-align: left;\n            }\n            .help-section-para {\n              font-size: 1rem;\n              font-family: N27-Light;\n              text-align: left;\n              font-style: italic;\n              margin-bottom: 1.5rem;\n            }\n          }\n        }\n      }\n    }\n    .box-2 {\n      border: 1px solid #3d3d3d;\n      width: 65%;\n      height: 100%;\n      .content-header {\n        border: 1px solid #9c9c9c;\n        height: 4.25rem;\n        display: flex;\n        justify-content: space-between;\n        padding-inline: 1.5rem;\n        align-items: center;\n        .expand-more {\n          cursor: pointer;\n        }\n        .content-level {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          .circle-green {\n            width: 0.75rem;\n            height: 0.75rem;\n            border-radius: 50%;\n            background-color: green; /* Change the color as needed */\n          }\n          .circle-orange {\n            width: 0.75rem;\n            height: 0.75rem;\n            border-radius: 50%;\n            background-color: orange; /* Change the color as needed */\n          }\n          .circle-red {\n            width: 0.75rem;\n            height: 0.75rem;\n            border-radius: 50%;\n            background-color: red; /* Change the color as needed */\n          }\n          .content-header-heading {\n            font-family: N27;\n            font-size: 1.5rem;\n          }\n        }\n        .content-heading {\n          font-size: 3.5rem;\n          font-family: PP-Nuebit;\n          font-weight: bold;\n        }\n\n        .content-time {\n          display: flex;\n          gap: 1.5rem;\n          .content-text {\n            font-size: 1.25rem;\n            font-family: N27;\n          }\n        }\n      }\n      .content-header-content {\n        border: 1px solid #9c9c9c;\n        background-color: #F5F5F5;\n        /* height: 25.688rem;  */\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding-top: 1.5rem;\n\n        .content-header-box {\n          /* height: 22.688rem; */\n          width: 95%;\n          display: flex;\n          flex-direction: column;\n          /* overflow-y: scroll; */\n          /* border: 1px solid rgb(2, 57, 236); */\n          .content-course-detail {\n            width: 100%;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            margin-bottom: 1.5rem;\n            .content-course-detail-text {\n              display: flex;\n              flex-direction: column;\n              gap: 0.5rem;\n              .content-course-detail-text-header {\n                display: flex;\n                font-family: N27;\n                font-size: 1.25rem;\n                display: flex;\n                align-items: center;\n                .text {\n                  margin-left: 0.5rem;\n                }\n                .image {\n                  margin-left: 1rem;\n                }\n              }\n              .text-para {\n                margin-left: 2.1rem;\n                font-family: N27-Light;\n                font: italic;\n                color: #7b7b7b;\n              }\n              .text-para {\n                text-align: left;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
